import { Axios, AxiosError, HttpStatusCode } from "axios";
import { ElNotification } from "element-plus";
import { VueElement } from "vue";
import { I18n, useI18n } from "vue-i18n";

function readBackendErrorMessage(data: unknown): string | null {
  if (!data) {
    return null;
  }

  if (typeof data === "string") {
    const trimmed = data.trim();
    return trimmed.length ? trimmed : null;
  }

  if (typeof data !== "object") {
    return null;
  }

  const payload = data as Record<string, unknown>;

  if (typeof payload.error === "string" && payload.error.trim().length) {
    return payload.error;
  }

  if (typeof payload.message === "string" && payload.message.trim().length) {
    return payload.message;
  }

  if (typeof payload.detail === "string" && payload.detail.trim().length) {
    return payload.detail;
  }

  if (Array.isArray(payload.detail)) {
    const detailMessages = payload.detail
      .map((entry) => {
        if (typeof entry === "string") {
          return entry;
        }

        if (entry && typeof entry === "object") {
          const entryPayload = entry as Record<string, unknown>;
          if (
            typeof entryPayload.msg === "string" &&
            entryPayload.msg.trim().length
          ) {
            return entryPayload.msg;
          }

          if (
            typeof entryPayload.message === "string" &&
            entryPayload.message.trim().length
          ) {
            return entryPayload.message;
          }
        }

        return null;
      })
      .filter((value): value is string => Boolean(value));

    if (detailMessages.length) {
      return detailMessages.join("; ");
    }
  }

  return null;
}

export function showResponseErrorToUser(error: unknown, t: Function) {
  const errorMessage = getResponseErrorMessage(error, t);
  ElNotification({
    title: t("error"),
    message: errorMessage,
    type: "error",
  });
}

export function getResponseErrorMessage(error: unknown, t: Function): string {
  if (error instanceof AxiosError && error.response) {
    if ((error as AxiosError)?.response?.status === HttpStatusCode.Forbidden) {
      return t("accessDenied");
    }

    const backendErrorMessage = readBackendErrorMessage(error.response.data);
    if (backendErrorMessage) {
      return backendErrorMessage;
    }
  }

  return t("genericError");
}
